import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable max-len */ import logger from 'common/utils/udp-logger';
import { formatUrlDomain } from '../helpers/getDomains';
import { checkAccountType } from './partners-utils';
import { formatUrlInText, formatUrlString, getVideoIframeUrl } from './url-utils';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ROW_NUMBER = {
    // 一行多少个
    THREE: 3,
    TWO: 2
};
// formatUrlInText用于富文本，formatUrlString用于单个链接
/**
 * html模板数据处理
 * @param {*} cssContent css代码片段
 * @param {*} htmlContent html代码片段
 * @param {*} jsContent js代码片段
 * @returns {*} configuration
 */ var handleHTMLData = function(cssContent, htmlContent, jsContent) {
    var configuration = [
        {
            tag: 'div',
            inner: formatUrlInText(htmlContent)
        }, 
    ];
    if (cssContent.startsWith('<style')) {
        var cssInner = cssContent.match(/<style>(.+)<\/style>/);
        if (cssInner && cssInner[1]) {
            configuration.push({
                tag: 'style',
                attrs: {},
                inner: cssInner[1]
            });
        }
    }
    if (cssContent.startsWith('<link')) {
        var cssHref = cssContent.match(/href="([^"]+)"/);
        if (cssHref && cssHref[1]) {
            configuration.push({
                tag: 'link',
                attrs: {
                    rel: 'stylesheet',
                    href: cssHref[1]
                }
            });
        }
    }
    if (jsContent.startsWith('<script')) {
        var jsSrc = jsContent.match(/src="([^"]+)"/);
        if (jsSrc && jsSrc[1]) {
            configuration.push({
                tag: 'script',
                attrs: {
                    type: 'text/javascript',
                    src: jsSrc[1]
                }
            });
        } else {
            var jsInner = jsContent.match(/<script.*?>(.+)<\/script>/);
            if (jsInner && jsInner[1]) {
                configuration.push({
                    tag: 'script',
                    attrs: {
                        type: 'text/javascript'
                    },
                    inner: jsInner[1]
                });
            }
        }
    }
    return configuration;
};
// 定价页产品服务介绍
var formatPriceTabData = function(data) {
    var ret = data.map(function(oneTab) {
        var title1 = oneTab.title, children = oneTab.children, doubleIcon = oneTab.doubleIcon;
        var childrenList = children.map(function(oneChild) {
            var title = oneChild.title, desc = oneChild.desc, to = oneChild.to, isCalcOnline = oneChild.isCalcOnline;
            return {
                title: title,
                text: desc,
                link: formatUrlDomain(to),
                hasCalculator: isCalcOnline
            };
        });
        return {
            title: title1,
            logo: doubleIcon,
            intro_list: childrenList
        };
    });
    return ret;
};
// 联系我们
var formatContact = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var isNewContact = keys.length >= 9;
    var isMoreButtons = keys.length === 6;
    var modTitle = properties[keys[0]].default;
    var title = properties[keys[1]].default;
    var content = properties[keys[2]].default;
    var pcBackgroundImage = '';
    var mbBackgroundImage = '';
    var txt1 = '';
    var href1 = '';
    var colType1 = 'white';
    var sizeType1 = 'center';
    var buttonConfig = [];
    if (isMoreButtons) {
        pcBackgroundImage = properties[keys[3]].default;
        mbBackgroundImage = properties[keys[4]].default;
        buttonConfig = properties[keys[5]].default.map(function(item, index) {
            var ref = clearRandomKey(item), _txt = ref.txt, txt = _txt === void 0 ? '' : _txt, _href = ref.href, href = _href === void 0 ? '' : _href, _colType = ref.colType, colType = _colType === void 0 ? '' : _colType, _sizeType = ref.sizeType, sizeType = _sizeType === void 0 ? '' : _sizeType;
            return {
                txt: txt,
                href: formatUrlString(href),
                colType: colType,
                sizeType: sizeType,
                alignType: 'center',
                extendProps: {
                    'report-event': 'click_contact_us_button',
                    'report-event-goal': 'click_contact_us_button',
                    'report-ext1': index,
                    'report-ext2': txt,
                    'report-ext3': href
                }
            };
        });
    } else {
        if (isNewContact) {
            pcBackgroundImage = properties[keys[3]].default;
            mbBackgroundImage = properties[keys[4]].default;
            txt1 = properties[keys[5]].default;
            href1 = formatUrlString(properties[keys[6]].default);
            colType1 = properties[keys[7]].default;
            sizeType1 = properties[keys[8]].default;
        } else {
            txt1 = properties[keys[3]].default;
            href1 = formatUrlString(properties[keys[4]].default);
        }
        buttonConfig = [
            {
                txt: txt1,
                href: href1,
                colType: colType1,
                sizeType: sizeType1,
                alignType: 'center',
                extendProps: {
                    'report-event': 'click_contact_us_button',
                    'report-event-goal': 'click_contact_us_button',
                    'report-ext1': txt1,
                    'report-ext2': href1
                }
            }, 
        ];
    }
    return {
        modTitle: modTitle,
        title: title,
        content: content,
        pcBackgroundImage: pcBackgroundImage,
        mbBackgroundImage: mbBackgroundImage,
        buttonConfig: buttonConfig,
        extendProps: {
            'report-event-goal': 'click_contact_us'
        }
    };
};
// 选项卡组件
var formatArchitecture = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    var bgColor = getComponentsBgColor(properties, keys);
    for(var i = 0; i < Math.floor(keys.length / 3); i++){
        // 目前选项卡组件最大只支持3个tab
        var title = properties[keys[0 + i * 3]].default; // title在默认保存时为''
        var content = properties[keys[1 + i * 3]].default; // 默认为''
        var imageSrc = properties[keys[2 + i * 3]].value ? properties[keys[2 + i * 3]].value[0] ? formatUrlString(properties[keys[2 + i * 3]].value[0].url) : '' : '';
        var itemData = {
            key: "".concat(i + 1),
            title: title,
            tabTitle: title,
            content: content,
            imageSrc: imageSrc
        };
        configuration.push(itemData);
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatBanner = function(properties) {
    var genBannerButtonItem = function genBannerButtonItem(btnVideoBg, video, btnText, btnLink, index) {
        var item = {
            label: btnText,
            extendProps: {
                'report-event': 'click_banner_button',
                'report-event-goal': 'click_contact_us',
                'report-ext1': btnText,
                'report-ext2': index
            }
        };
        if (btnVideoBg && video) {
            item = _objectSpread({}, item, {
                filedVideoBg: btnVideoBg,
                filedVideoList: video,
                postMessageUrl: getVideoIframeUrl()
            });
        } else {
            item = _objectSpread({}, item, {
                href: btnLink
            });
        }
        return item;
    };
    var formatString = /*
   * 格式化cms端传递过来的对应内容：
   * 1、判断目标字符串能否被转换为数组
   * 2、数组中的每一项为对象且有 text、href 和 chosed 属性
   * 如果都满足，返回对应的转换JSON后的内容，否则返回 []
   */ function formatString(content) {
        // 因为cms配置的数据项中，当 chosed 属性为 false 时不输出，
        // 所以需要一个新数据来存储格式化后的数据-当没有chosed属性时
        var newContent = [];
        if (Object.prototype.toString.call(content) === '[object Array]') {
            for(var i = 0; i < content.length; i++){
                var item = content[i];
                // eslint-disable-next-line no-prototype-builtins
                if (!(Object.prototype.hasOwnProperty.call(item, 'text') && Object.prototype.hasOwnProperty.call(item, 'href'))) {
                    return [];
                }
                if (!Object.prototype.hasOwnProperty.call(item, 'chosed')) {
                    newContent.push(_objectSpread({}, item, {
                        chosed: false
                    }));
                } else {
                    newContent.push(item);
                }
            }
            return newContent;
        }
        return [];
    };
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var title = properties[keys[0]].default;
    var article = formatUrlInText(properties[keys[1]].default);
    var leftBtnText = properties[keys[2]].default;
    var leftBtnLink = formatUrlString(properties[keys[3]].default);
    var leftBtnVideoBg = properties[keys[4]].value ? properties[keys[4]].value[0] ? properties[keys[4]].value[0].url : '' : '';
    var leftVideo = properties[keys[5]].value ? properties[keys[5]].value[0] ? properties[keys[5]].value[0].url : '' : '';
    var rightBtnText = properties[keys[6]].default;
    var rightBtnLink = formatUrlString(properties[keys[7]].default);
    var rightBtnVideoBg = properties[keys[8]].value ? properties[keys[8]].value[0] ? properties[keys[8]].value[0].url : '' : '';
    var rightVideo = properties[keys[9]].value ? properties[keys[9]].value[0] ? properties[keys[9]].value[0].url : '' : '';
    var imageSrc = properties[keys[10]].value ? properties[keys[10]].value[0] ? properties[keys[10]].value[0].url : '' : '';
    var backgroundUrlLogo = properties[keys[11]] ? properties[keys[11]].value ? properties[keys[11]].value[0] ? properties[keys[11]].value[0].url : '' : '' : '';
    var buttonList = [];
    if (leftBtnText) {
        var item2 = genBannerButtonItem(leftBtnVideoBg, leftVideo, leftBtnText, leftBtnLink, 0);
        buttonList.push(item2);
    }
    if (rightBtnText) {
        var item1 = genBannerButtonItem(rightBtnVideoBg, rightVideo, rightBtnText, rightBtnLink, 1);
        buttonList.push(item1);
    }
    var insights = [
        {
            title: title,
            content: article
        }, 
    ];
    // 兼容以前的 Banner组件 - 没有 switchContent 这个组件的数据；
    var switchList;
    try {
        var switchContent = properties[keys[12]] ? properties[keys[12]].default.map(function(item) {
            return clearRandomKey(item);
        }) : [];
        switchList = formatString(switchContent);
    } catch (error) {
        logger.error(error);
        switchList = [];
    }
    return {
        imageSrc: imageSrc,
        backgroundUrlLogo: backgroundUrlLogo,
        insights: insights,
        buttonList: buttonList,
        switchList: switchList
    };
};
var formatBenefits = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    var bgColor = getComponentsBgColor(properties, keys);
    var count = 2;
    for(var i = 0; i < Math.floor(keys.length / count); i++){
        // eslint-disable-next-line max-len
        var article = properties[keys[0 + i * count]].default && formatUrlInText(properties[keys[0 + i * count]].default); // 默认为''
        var imageSrc = properties[keys[1 + i * count]].value ? properties[keys[1 + i * count]].value[0] ? formatUrlString(properties[keys[1 + i * count]].value[0].url) : '' : '';
        if (article) {
            var itemData = {
                article: article,
                imageSrc: imageSrc
            };
            configuration.push(itemData);
        }
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatBenefitsTab = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    var bgColor = getComponentsBgColor(properties, keys);
    var count = 4;
    for(var i = 0; i < Math.floor(keys.length / count); i++){
        var tabTitle = properties[keys[0 + i * count]].default; // 默认为''
        var article = formatUrlInText(properties[keys[1 + i * count]].default); // 默认为''
        var imageAlt = properties[keys[2 + i * count]].default; // 默认为''
        var imageSrc = properties[keys[3 + i * count]].value ? properties[keys[3 + i * count]].value[0] ? formatUrlString(properties[keys[3 + i * count]].value[0].url) : '' : '';
        if (article) {
            var itemData = {
                key: "".concat(i + 1),
                tabTitle: tabTitle,
                article: article,
                imageAlt: imageAlt,
                imageSrc: imageSrc
            };
            configuration.push(itemData);
        }
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatBuyNowNew = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    // console.log(keys, 'keys-formatBuyNowNew');
    // console.log(properties, 'properties-formatBuyNowNew');
    var newProperties = clearRandomKey(properties);
    if (Object.prototype.hasOwnProperty.call(newProperties, 'checkbox2')) {
        var count = 9;
        for(var i = 0; i < Math.floor(keys.length / count); i++){
            var title = properties[keys[0 + i * count]].default;
            var description = properties[keys[1 + i * count]].default;
            var content = formatUrlInText(properties[keys[2 + i * count]].default);
            var butTxt = properties[keys[3 + i * count]].default;
            var butHref = formatUrlString(properties[keys[4 + i * count]].default);
            var isConnect = properties[keys[5 + i * count]].default;
            var isLink = properties[keys[6 + i * count]].default;
            var event = properties[keys[7 + i * count]].default;
            var commodity = properties[keys[8 + i * count]].default;
            if (title) {
                var itemData = {
                    title: title,
                    description: description,
                    content: content,
                    but_txt: butTxt,
                    isConnect: isConnect,
                    isLink: isLink,
                    but_href: butHref,
                    event: event,
                    commodity: commodity
                };
                configuration.push(itemData);
            }
        }
    } else {
        var count1 = 8;
        for(var i1 = 0; i1 < Math.floor(keys.length / count1); i1++){
            var title2 = properties[keys[0 + i1 * count1]].default;
            var description1 = properties[keys[1 + i1 * count1]].default;
            var content1 = formatUrlInText(properties[keys[2 + i1 * count1]].default);
            var butTxt1 = properties[keys[3 + i1 * count1]].default;
            var butHref1 = formatUrlString(properties[keys[4 + i1 * count1]].default);
            var isConnect1 = properties[keys[5 + i1 * count1]].default;
            var event1 = properties[keys[6 + i1 * count1]].default;
            var commodity1 = properties[keys[7 + i1 * count1]].default;
            if (title2) {
                var itemData1 = {
                    title: title2,
                    description: description1,
                    content: content1,
                    but_txt: butTxt1,
                    isConnect: isConnect1,
                    but_href: butHref1,
                    event: event1,
                    commodity: commodity1
                };
                configuration.push(itemData1);
            }
        }
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatBuyNowOld = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    if (keys.length > 2) {
        // 字段个数大于2的为老数据
        var count = 5;
        for(var i = 0; i < Math.floor(keys.length / count); i++){
            var title = properties[keys[0 + i * count]].default;
            var description = properties[keys[1 + i * count]].default;
            var content = formatUrlInText(properties[keys[2 + i * count]].default);
            var butTxt = properties[keys[3 + i * count]].default;
            var butHref = formatUrlString(properties[keys[4 + i * count]].default);
            if (title) {
                var itemData = {
                    title: title,
                    description: description,
                    content: content,
                    but_txt: butTxt,
                    but_href: butHref,
                    extendProps: {
                        'report-event-goal': 'click_offer',
                        'report-event': 'click_buy_now_button',
                        'report-ext1': title,
                        'report-ext2': i,
                        'report-ext3': butTxt,
                        'report-ext4': butHref
                    }
                };
                configuration.push(itemData);
            }
        }
    } else {
        var ref1 = clearRandomKey(properties), _buyNowList = ref1.buyNowList, buyNowList = _buyNowList === void 0 ? {} : _buyNowList;
        configuration = (buyNowList.default || []).map(function(item, index) {
            var ref = clearRandomKey(item), _input1 = ref.input1, input1 = _input1 === void 0 ? '' : _input1, _input2 = ref.input2, input2 = _input2 === void 0 ? '' : _input2, _textarea1 = ref.textarea1, textarea1 = _textarea1 === void 0 ? '' : _textarea1, _input3 = ref.input3, input3 = _input3 === void 0 ? '' : _input3, _input4 = ref.input4, input4 = _input4 === void 0 ? '' : _input4;
            return {
                title: input1,
                description: input2,
                content: textarea1,
                but_txt: input3,
                but_href: input4,
                extendProps: {
                    'report-event-goal': 'click_offer',
                    'report-event': 'click_buy_now_button',
                    'report-ext1': input1,
                    'report-ext2': index,
                    'report-ext3': input3,
                    'report-ext4': input4
                }
            };
        });
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
// 选项卡组件
var formatQuickstarts = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    var bgColor = getComponentsBgColor(properties, keys);
    for(var i = 0; i < Math.floor(keys.length / 2); i++){
        // 目前选项卡组件最大只支持3个tab
        var title = properties[keys[0 + i * 2]].default; // title在默认保存时为''
        var content = properties[keys[1 + i * 2]].default; // 默认为''
        if (title || content) {
            var itemData = {
                key: "".concat(i + 1),
                title: title,
                content: content
            };
            configuration.push(itemData);
        }
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatCustomers = function(properties, diff) {
    var keys = Object.keys(properties);
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    var configuration = [];
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    switch(diff){
        case 'textUrl':
            {
                // 对应属性的key值，规则按3个为一组数据
                // 对应的是 FlexTextArticle 组件，自定义的text&url
                var count = 2; // 4
                for(var i = 0; i < Math.floor(keys.length / count); i++){
                    var title = properties[keys[0 + i * count]].default; // title在默认保存时为''
                    var content = formatUrlInText(properties[keys[1 + i * count]].default); // 默认为''
                    // const href = properties[keys[2 + i * count]].default;
                    // const hrefText = properties[keys[3 + i * count]].default;
                    if (content) {
                        var itemData = {
                            key: "".concat(i + 1),
                            title: title,
                            content: content
                        };
                        configuration.push(itemData);
                    }
                }
                return {
                    configuration: configuration,
                    modTitle: modTitle,
                    bgColor: bgColor
                };
            }
        case 'areaCard':
            {
                var areaCardObj = clearRandomKey(properties);
                var mergeComponentStatus = false;
                if (Object.prototype.hasOwnProperty.call(areaCardObj, 'mergeComponentStatus')) {
                    mergeComponentStatus = areaCardObj.mergeComponentStatus.default || false;
                    keys.shift();
                }
                if (Object.prototype.hasOwnProperty.call(areaCardObj, 'bindingNum')) {
                    // 对应属性的key值，规则按4个为一组数据
                    for(var i2 = 0; i2 < Math.floor(keys.length / 7); i2++){
                        var title3 = properties[keys[0 + i2 * 7]].default; // title在默认保存时为''
                        var content2 = formatUrlInText(properties[keys[1 + i2 * 7]].default); // 默认为''
                        var href = formatUrlString(properties[keys[2 + i2 * 7]].default);
                        var hrefText = properties[keys[3 + i2 * 7]].default;
                        var source = properties[keys[4 + i2 * 7]].value ? properties[keys[4 + i2 * 7]].value[0] ? formatUrlString(properties[keys[4 + i2 * 7]].value[0].url) : '' : '';
                        var tabIndex = properties[keys[5 + i2 * 7]].default;
                        var bindingNum = properties[keys[6 + i2 * 7]].default;
                        if (title3 || content2) {
                            var itemData2 = {
                                key: "".concat(i2 + 1),
                                title: title3,
                                content: content2,
                                href: href,
                                hrefText: hrefText,
                                source: source,
                                tabIndex: tabIndex,
                                bindingNum: bindingNum,
                                extendProps: {
                                    'report-event-goal': 'click_dl_doc'
                                }
                            };
                            configuration.push(itemData2);
                        }
                    }
                } else {
                    // 对应属性的key值，规则按4个为一组数据
                    for(var i3 = 0; i3 < Math.floor(keys.length / 5); i3++){
                        var title4 = properties[keys[0 + i3 * 5]].default; // title在默认保存时为''
                        var content3 = formatUrlInText(properties[keys[1 + i3 * 5]].default); // 默认为''
                        var href2 = formatUrlString(properties[keys[2 + i3 * 5]].default);
                        var hrefText1 = properties[keys[3 + i3 * 5]].default;
                        var source1 = properties[keys[4 + i3 * 5]].value ? properties[keys[4 + i3 * 5]].value[0] ? formatUrlString(properties[keys[4 + i3 * 5]].value[0].url) : '' : '';
                        if ((title4 || content3) && href2 && hrefText1) {
                            var itemData3 = {
                                key: "".concat(i3 + 1),
                                title: title4,
                                content: content3,
                                href: href2,
                                hrefText: hrefText1,
                                source: source1,
                                extendProps: {
                                    'report-event-goal': 'click_dl_doc'
                                }
                            };
                            configuration.push(itemData3);
                        }
                    }
                }
                return {
                    configuration: configuration,
                    mergeComponentStatus: mergeComponentStatus,
                    modTitle: modTitle,
                    bgColor: bgColor
                };
            }
        case 'picText':
            {
                // 对应的是 Customers 组件，图片 + 文字
                // 对应属性的key值，规则按3个为一组数据
                if (keys.length > 2) {
                    // 字段大于2的为老版数据，做兼容处理避免线上500
                    var count2 = 5;
                    for(var i4 = 0; i4 < Math.floor(keys.length / count2); i4++){
                        var title5 = properties[keys[0 + i4 * count2]].default; // title在默认保存时为''
                        var content4 = formatUrlInText(properties[keys[1 + i4 * count2]].default); // 默认为''
                        var hrefText2 = properties[keys[2 + i4 * count2]].default;
                        var href3 = formatUrlString(properties[keys[3 + i4 * count2]].default);
                        var source2 = properties[keys[4 + i4 * count2]].value ? properties[keys[4 + i4 * count2]].value[0] ? formatUrlString(properties[keys[4 + i4 * count2]].value[0].url) : '' : '';
                        if (title5 || content4) {
                            var itemData4 = {
                                key: "".concat(i4 + 1),
                                title: title5,
                                content: content4,
                                source: source2,
                                href: href3,
                                hrefText: hrefText2
                            };
                            configuration.push(itemData4);
                        }
                    }
                } else {
                    var list = properties[keys[0]].default || [];
                    configuration = list.map(function(item, index) {
                        var ref = clearRandomKey(item), _input1 = ref.input1, input1 = _input1 === void 0 ? '' : _input1, _textarea1 = ref.textarea1, textarea1 = _textarea1 === void 0 ? '' : _textarea1, _input3 = ref.input3, input3 = _input3 === void 0 ? '' : _input3, _input4 = ref.input4, input4 = _input4 === void 0 ? '' : _input4, _upload1 = ref.upload1, upload1 = _upload1 === void 0 ? '' : _upload1;
                        return {
                            key: "".concat(index + 1),
                            title: input1,
                            content: textarea1,
                            href: input4,
                            hrefText: input3,
                            source: upload1
                        };
                    });
                }
                return {
                    configuration: configuration,
                    modTitle: modTitle,
                    bgColor: bgColor
                };
            }
        case 'logoText':
            {
                // 对应的是 Customers 组件，logo + 文字
                // 对应属性的key值，规则按2个为一组数据
                if (keys.length >= 2) {
                    // 字段大于2的为老版数据，做兼容处理避免线上500
                    for(var i5 = 0; i5 < Math.floor(keys.length / 2); i5++){
                        var title6 = properties[keys[0 + i5 * 2]].default; // title在默认保存时为''
                        var imageSrc = properties[keys[1 + i5 * 2]].value ? properties[keys[1 + i5 * 2]].value[0] ? formatUrlString(properties[keys[1 + i5 * 2]].value[0].url) : '' : '';
                        if (title6 || imageSrc) {
                            var itemData5 = {
                                key: "".concat(i5 + 1),
                                title: title6,
                                imageSrc: imageSrc
                            };
                            configuration.push(itemData5);
                        }
                    }
                } else {
                    var list1 = properties[keys[0]].default || [];
                    configuration = list1.map(function(item, index) {
                        var ref = clearRandomKey(item), _input1 = ref.input1, input1 = _input1 === void 0 ? '' : _input1, _upload1 = ref.upload1, upload1 = _upload1 === void 0 ? '' : _upload1;
                        return {
                            key: "".concat(index + 1),
                            title: input1,
                            imageSrc: upload1
                        };
                    });
                }
                return {
                    configuration: configuration,
                    modTitle: modTitle,
                    bgColor: bgColor
                };
            }
        case 'circleLogoText':
            {
                // 对应的是 Customers 组件，logo + 文字
                // 对应属性的key值，规则按2个为一组数据
                var description = properties[keys[0]].default; // 第一条数据是模块名称
                keys.shift(); // 把模块名移出，继续遍历后面的数据
                // 兼容新老数据解析处理
                if (keys.length >= 2) {
                    // 字段大于2的为老版数据，做兼容处理避免线上500
                    var count3 = 2;
                    for(var i6 = 0; i6 < Math.floor(keys.length / count3); i6++){
                        var title7 = properties[keys[0 + i6 * count3]].default;
                        var imageSrc1 = properties[keys[1 + i6 * count3]].value ? properties[keys[1 + i6 * count3]].value[0] ? properties[keys[1 + i6 * count3]].value[0].url : '' : '';
                        var itemData6 = {
                            key: "".concat(i6 + 1),
                            title: title7,
                            imageSrc: imageSrc1
                        };
                        configuration.push(itemData6);
                    }
                } else {
                    var list2 = properties[keys[0]].default || [];
                    configuration = list2.map(function(item, index) {
                        var ref = clearRandomKey(item), _title = ref.title, title = _title === void 0 ? '' : _title, _imageSrc = ref.imageSrc, imageSrc = _imageSrc === void 0 ? '' : _imageSrc, _href = ref.href, href = _href === void 0 ? '' : _href;
                        return {
                            key: index + 1,
                            title: title,
                            imageSrc: imageSrc,
                            url: href
                        };
                    });
                }
                return {
                    configuration: configuration,
                    modTitle: modTitle,
                    description: description,
                    bgColor: bgColor
                };
            }
        case 'iconText':
            {
                // 对应的是 Customers 组件，图标 + 文字
                // 对应属性的key值，规则按3个为一组数据
                for(var i7 = 0; i7 < Math.floor(keys.length / 3); i7++){
                    var title8 = properties[keys[0 + i7 * 3]].default; // title在默认保存时为''
                    var article = formatUrlInText(properties[keys[1 + i7 * 3]].default);
                    var imageSrc2 = properties[keys[2 + i7 * 3]].value ? properties[keys[2 + i7 * 3]].value[0] ? formatUrlString(properties[keys[2 + i7 * 3]].value[0].url) : '' : '';
                    if (title8 || article) {
                        var itemData7 = {
                            title: title8,
                            article: article,
                            imageSrc: imageSrc2
                        };
                        configuration.push(itemData7);
                    }
                }
                return {
                    configuration: configuration,
                    modTitle: modTitle,
                    bgColor: bgColor
                };
            }
        case 'html':
            {
                var cssContent = properties[keys[0]].default;
                var htmlContent = properties[keys[1]].default;
                var jsContent = properties[keys[2]].default;
                return {
                    configuration: handleHTMLData(cssContent, htmlContent, jsContent),
                    modTitle: modTitle
                };
            }
        default:
            break;
    }
    return {
        modTitle: '',
        configuration: '',
        bgColor: ''
    };
};
var formatMultipleScenarios = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var articleList = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    for(var i = 0; i < 4; i++){
        // 最多遍历前面 8 条数据，这个组件设计成前面8条数据，用来构建 articleList
        var title = properties[keys[0 + i * 2]].default; // title在默认保存时为''
        var content = formatUrlInText(properties[keys[1 + i * 2]].default); // 默认为''
        var itemData = {
            title: title,
            content: content
        };
        articleList.push(itemData);
    }
    var imageSrc = properties[keys[8]].value ? properties[keys[8]].value[0] ? formatUrlString(properties[keys[8]].value[0].url) : '' : ''; // 图片暂时是第9位，后面新增字段，此次要调整
    var imageLocation = properties[keys[9]] ? properties[keys[9]].default : true; // 图片左右,兼容以前字段缺省默认为true
    var configuration = {
        imageLocation: imageLocation,
        imageSrc: imageSrc,
        articleList: articleList
    };
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatRelatedProducts = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    for(var i = 0; i < Math.floor(keys.length / 5); i++){
        // 数据是5个一组
        var title = properties[keys[0 + i * 5]].default; // title在默认保存时为''
        var content = properties[keys[1 + i * 5]].default; // 默认为''
        var href = formatUrlString(properties[keys[2 + i * 5]].default);
        var hrefText = properties[keys[3 + i * 5]].default;
        var source = properties[keys[4 + i * 5]].value ? properties[keys[4 + i * 5]].value[0] ? formatUrlString(properties[keys[4 + i * 5]].value[0].url) : '' : '';
        if (title || content) {
            // 标题和内容必须有，才会认为是正常数据，可以展示
            var itemData = {
                key: "".concat(i + 1),
                title: title,
                content: content,
                source: source
            };
            if (href && hrefText) {
                // 链接地址和链接文案一起配置了才会当作是有效配置
                itemData = _objectSpread({}, itemData, {
                    href: href,
                    hrefText: hrefText
                });
            }
            configuration.push(itemData);
        }
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatScenarios = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    var bgColor = getComponentsBgColor(properties, keys);
    for(var i = 0; i < Math.floor(keys.length / 6); i++){
        // 数据是4个一组
        var tabTitle = properties[keys[0 + i * 6]].default; // title在默认保存时为''
        var title = properties[keys[1 + i * 6]].default; // 默认为''
        var content = properties[keys[2 + i * 6]].default;
        var imageSrc = properties[keys[3 + i * 6]].value ? properties[keys[3 + i * 6]].value[0] ? formatUrlString(properties[keys[3 + i * 6]].value[0].url) : '' : '';
        var filedVideoBg = properties[keys[4 + i * 6]].value ? properties[keys[4 + i * 6]].value[0] ? formatUrlString(properties[keys[4 + i * 6]].value[0].url) : '' : '';
        var filedVideoList = properties[keys[5 + i * 6]].value ? properties[keys[5 + i * 6]].value[0] ? formatUrlString(properties[keys[5 + i * 6]].value[0].url) : '' : '';
        if (title || content) {
            // 标题和内容必须有，才会认为是正常数据，可以展示
            var itemData = {
                key: "".concat(i + 1),
                tabTitle: tabTitle,
                title: title,
                content: content,
                imageSrc: imageSrc,
                filedVideoBg: filedVideoBg,
                filedVideoList: filedVideoList,
                postMessageUrl: getVideoIframeUrl()
            };
            configuration.push(itemData);
        }
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatScenariosCard = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    var bgColor = getComponentsBgColor(properties, keys);
    var count = 4;
    for(var i = 0; i < Math.floor(keys.length / count); i++){
        // 数据是count个一组
        var title = properties[keys[0 + i * count]].default; // title在默认保存时为''
        var content = properties[keys[1 + i * count]].default; // 默认为''
        var source = properties[keys[2 + i * count]].value ? properties[keys[2 + i * count]].value[0] ? formatUrlString(properties[keys[2 + i * count]].value[0].url) : '' : '';
        var filedVideoList = properties[keys[3 + i * count]].value ? properties[keys[3 + i * count]].value[0] ? formatUrlString(properties[keys[3 + i * count]].value[0].url) : '' : '';
        if (title || content) {
            // 标题和内容必须有，才会认为是正常数据，可以展示
            var itemData = {
                key: "".concat(i + 1),
                title: title,
                content: content,
                source: source,
                filedVideoBg: filedVideoList ? source : '',
                filedVideoList: filedVideoList,
                postMessageUrl: getVideoIframeUrl()
            };
            configuration.push(itemData);
        }
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatStoriesScenarios = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    for(var i = 0; i < Math.floor(keys.length / 9); i++){
        // 数据是3个一组
        var tabTitle = properties[keys[0 + i * 9]].default; // title在默认保存时为''
        var title = properties[keys[1 + i * 9]].default; // 默认为''
        var href = formatUrlString(properties[keys[2 + i * 9]].default); // title在默认保存时为''
        var hrefText = properties[keys[3 + i * 9]].default; // 默认为''
        var content = properties[keys[4 + i * 9]].default; // title在默认保存时为''
        var TabImageSrc = properties[keys[5 + i * 9]].value ? properties[keys[5 + i * 9]].value[0] ? formatUrlString(properties[keys[5 + i * 9]].value[0].url) : '' : '';
        var imageSrc = properties[keys[6 + i * 9]].value ? properties[keys[6 + i * 9]].value[0] ? formatUrlString(properties[keys[6 + i * 9]].value[0].url) : '' : '';
        var filedVideoBg = properties[keys[7 + i * 9]].value ? properties[keys[7 + i * 9]].value[0] ? formatUrlString(properties[keys[7 + i * 9]].value[0].url) : '' : '';
        var filedVideoList = properties[keys[8 + i * 9]].value ? properties[keys[8 + i * 9]].value[0] ? formatUrlString(properties[keys[8 + i * 9]].value[0].url) : '' : '';
        if (tabTitle && (title || content || href && hrefText)) {
            // 标题和内容必须有，才会认为是正常数据，可以展示
            var itemData = {
                key: "".concat(i + 1),
                tabTitle: tabTitle,
                title: title,
                content: content,
                href: href,
                hrefText: hrefText,
                TabImageSrc: TabImageSrc,
                imageSrc: imageSrc,
                filedVideoBg: filedVideoBg,
                filedVideoList: filedVideoList,
                postMessageUrl: getVideoIframeUrl()
            };
            configuration.push(itemData);
        }
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatSceneChange = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var configuration = [];
    if (keys.length > 2) {
        // 字段大于2的为老版数据，做兼容处理避免线上500
        var count = 7;
        for(var i = 0; i < Math.floor(keys.length / count); i++){
            // 数据是3个一组
            var title = properties[keys[0 + i * count]].default;
            var content = formatUrlInText(properties[keys[1 + i * count]].default);
            var hrefText = properties[keys[2 + i * count]].default;
            var href = formatUrlString(properties[keys[3 + i * count]].default);
            var logoImg = properties[keys[4 + i * count]].value ? properties[keys[4 + i * count]].value[0] ? formatUrlString(properties[keys[4 + i * count]].value[0].url) : '' : '';
            var filedVideoBg = properties[keys[5 + i * count]].value ? properties[keys[5 + i * count]].value[0] ? formatUrlString(properties[keys[5 + i * count]].value[0].url) : '' : '';
            var filedVideoList = properties[keys[6 + i * count]].value ? properties[keys[6 + i * count]].value[0] ? formatUrlString(properties[keys[6 + i * count]].value[0].url) : '' : '';
            var itemData = {
                key: "".concat(i + 1),
                title: title,
                content: content,
                href: href,
                hrefText: hrefText,
                logoImg: logoImg,
                source: filedVideoBg,
                filedVideoBg: filedVideoBg,
                filedVideoList: filedVideoList,
                postMessageUrl: getVideoIframeUrl()
            };
            configuration.push(itemData);
        }
    } else {
        var list = properties[keys[0]].default || [];
        configuration = list.map(function(tabsItem, index) {
            var noRandomKeyTabOne = clearRandomKey(tabsItem);
            var title = noRandomKeyTabOne.input1 || '';
            var content = noRandomKeyTabOne.string1 || '';
            var href = noRandomKeyTabOne.input3 || '';
            var hrefText = noRandomKeyTabOne.input2 || '';
            var logoImg = noRandomKeyTabOne.upload1 || '';
            var filedVideoBg = noRandomKeyTabOne.upload2 || '';
            var filedVideoList = noRandomKeyTabOne.upload3 || '';
            return {
                key: "".concat(index + 1),
                title: title,
                content: content,
                href: href,
                hrefText: hrefText,
                logoImg: logoImg,
                source: filedVideoBg,
                filedVideoBg: filedVideoBg,
                filedVideoList: filedVideoList,
                postMessageUrl: getVideoIframeUrl()
            };
        });
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatProductIntroduction = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var count = 3;
    for(var i = 0; i < Math.floor(keys.length / count); i++){
        var article = formatUrlInText(properties[keys[0 + i * count]].default);
        var rightPicStyle = properties[keys[1 + i * count]];
        var rightPicKeys = Object.keys(rightPicStyle.properties);
        var rightVideoStyle = properties[keys[2 + i * count]];
        var rightVideoKeys = Object.keys(rightVideoStyle.properties);
        var imageUrl = '';
        var imageBgText = '';
        var imageBgTextHref = '';
        var filedVideoBg = '';
        var filedVideoList = '';
        for(var k = 0; k < Math.floor(rightPicKeys.length / 3); k++){
            imageUrl = rightPicStyle.properties[rightPicKeys[0]].value ? rightPicStyle.properties[rightPicKeys[0]].value[0] ? formatUrlString(rightPicStyle.properties[rightPicKeys[0]].value[0].url) : '' : '';
            imageBgText = rightPicStyle.properties[rightPicKeys[1]].default;
            imageBgTextHref = formatUrlString(rightPicStyle.properties[rightPicKeys[2]].default);
        }
        for(var j = 0; j < Math.floor(rightVideoKeys.length / 2); j++){
            filedVideoBg = rightVideoStyle.properties[rightVideoKeys[0]].value ? rightVideoStyle.properties[rightVideoKeys[0]].value[0] ? formatUrlString(rightVideoStyle.properties[rightVideoKeys[0]].value[0].url) : '' : '';
            filedVideoList = rightVideoStyle.properties[rightVideoKeys[1]].value ? rightVideoStyle.properties[rightVideoKeys[1]].value[0] ? formatUrlString(rightVideoStyle.properties[rightVideoKeys[1]].value[0].url) : '' : '';
            // 优先视频的填写逻辑，filedVideoBg字段暂时没用
            if (filedVideoBg) {
                imageUrl = filedVideoBg;
            }
        }
        var extendProps = {
            'report-event': 'click_product_introduction_video',
            'report-ext1': modTitle,
            'report-ext2': filedVideoList
        };
        var itemData = {
            article: article,
            imageUrl: imageUrl,
            filedVideoBg: filedVideoBg,
            filedVideoList: filedVideoList,
            postMessageUrl: getVideoIframeUrl(),
            extendProps: extendProps,
            imageBgText: imageBgText,
            imageBgTextHref: imageBgTextHref
        };
        configuration.push(itemData);
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor
    };
};
var formatSceneTabs = function(properties) {
    var keys = Object.keys(properties); // 属性的 key 值
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var sceneTabsObj = clearRandomKey(properties);
    var desc = '';
    if (Object.prototype.hasOwnProperty.call(sceneTabsObj, 'desc')) {
        desc = sceneTabsObj.mergeComponentStatus.default || false;
        keys.shift();
    }
    if (keys.length >= 11) {
        // 兼容数据格式变化导致的处理不同
        var count = 11;
        for(var i = 0; i < Math.floor(keys.length / count); i++){
            var title = properties[keys[0 + i * count]].default;
            var description = properties[keys[1 + i * count]].default;
            var imageUrl = properties[keys[2 + i * count]].value ? properties[keys[2 + i * count]].value[0] ? formatUrlString(properties[keys[2 + i * count]].value[0].url) : '' : '';
            var article = formatUrlInText(properties[keys[3 + i * count]].default);
            var related = properties[keys[4 + i * count]].default;
            var product = [];
            var proItem1 = properties[keys[5 + i * count]];
            var productKeys1 = Object.keys(proItem1.properties);
            var logo1 = proItem1.properties[productKeys1[0]].value ? proItem1.properties[productKeys1[0]].value[0] ? formatUrlString(proItem1.properties[productKeys1[0]].value[0].url) : '' : '';
            var proTitle1 = proItem1.properties[productKeys1[1]].default;
            var url1 = proItem1.properties[productKeys1[2]].default;
            var pro1 = {
                logo: logo1,
                title: proTitle1,
                url: url1
            };
            proTitle1 && product.push(pro1);
            var proItem2 = properties[keys[6 + i * count]];
            var productKeys2 = Object.keys(proItem2.properties);
            var logo2 = proItem2.properties[productKeys2[0]].value ? proItem2.properties[productKeys2[0]].value[0] ? formatUrlString(proItem2.properties[productKeys2[0]].value[0].url) : '' : '';
            var proTitle2 = proItem2.properties[productKeys2[1]].default;
            var url2 = proItem2.properties[productKeys2[2]].default;
            var pro2 = {
                logo: logo2,
                title: proTitle2,
                url: url2
            };
            proTitle2 && product.push(pro2);
            var proItem3 = properties[keys[7 + i * count]];
            var productKeys3 = Object.keys(proItem3.properties);
            var logo3 = proItem3.properties[productKeys3[0]].value ? proItem3.properties[productKeys3[0]].value[0] ? formatUrlString(proItem3.properties[productKeys3[0]].value[0].url) : '' : '';
            var proTitle3 = proItem3.properties[productKeys3[1]].default;
            var url3 = proItem3.properties[productKeys3[2]].default;
            var pro3 = {
                logo: logo3,
                title: proTitle3,
                url: url3
            };
            proTitle3 && product.push(pro3);
            var proItem4 = properties[keys[8 + i * count]];
            var productKeys4 = Object.keys(proItem4.properties);
            var logo4 = proItem4.properties[productKeys4[0]].value ? proItem4.properties[productKeys4[0]].value[0] ? formatUrlString(proItem4.properties[productKeys4[0]].value[0].url) : '' : '';
            var proTitle4 = proItem4.properties[productKeys4[1]].default;
            var url4 = proItem4.properties[productKeys4[2]].default;
            var pro4 = {
                logo: logo4,
                title: proTitle4,
                url: url4
            };
            proTitle4 && product.push(pro4);
            var proItem5 = properties[keys[9 + i * count]];
            var productKeys5 = Object.keys(proItem5.properties);
            var logo5 = proItem5.properties[productKeys5[0]].value ? proItem5.properties[productKeys5[0]].value[0] ? formatUrlString(proItem5.properties[productKeys5[0]].value[0].url) : '' : '';
            var proTitle5 = proItem5.properties[productKeys5[1]].default;
            var url5 = proItem5.properties[productKeys5[2]].default;
            var pro5 = {
                logo: logo5,
                title: proTitle5,
                url: url5
            };
            proTitle5 && product.push(pro5);
            var proItem6 = properties[keys[10 + i * count]];
            var productKeys6 = Object.keys(proItem6.properties);
            var logo6 = proItem6.properties[productKeys6[0]].value ? proItem6.properties[productKeys6[0]].value[0] ? formatUrlString(proItem6.properties[productKeys6[0]].value[0].url) : '' : '';
            var proTitle6 = proItem6.properties[productKeys6[1]].default;
            var url6 = proItem6.properties[productKeys6[2]].default;
            var pro6 = {
                logo: logo6,
                title: proTitle6,
                url: url6
            };
            proTitle6 && product.push(pro6);
            var itemData = {
                title: title,
                description: description,
                imageUrl: imageUrl,
                article: article,
                related: related,
                product: product
            };
            configuration.push(itemData);
        }
    } else {
        var list = properties[keys[0]].default || [];
        configuration = list.map(function(tabsItem, index) {
            var ref = clearRandomKey(tabsItem), _title = ref.title, title = _title === void 0 ? '' : _title, _description = ref.description, description = _description === void 0 ? '' : _description, _imageUrl = ref.imageUrl, imageUrl = _imageUrl === void 0 ? '' : _imageUrl, _article = ref.article, article = _article === void 0 ? '' : _article, _related = ref.related, related = _related === void 0 ? '' : _related, _product = ref.product, product = _product === void 0 ? [] : _product;
            var formatArticle = formatUrlInText(article);
            var resultList = product.map(function(item) {
                return clearRandomKey(item);
            });
            return {
                key: "".concat(index + 1),
                title: title,
                description: description,
                imageUrl: imageUrl,
                article: formatArticle,
                related: related,
                product: resultList
            };
        });
    }
    return {
        configuration: configuration,
        modTitle: modTitle,
        bgColor: bgColor,
        desc: desc
    };
};
var formatFreeWithCardNew = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    // console.log(properties, 'properties---99test');
    // console.log(keys, 'keys---keys');
    if (keys.length === 12) {
        var txt = properties[keys[0]].default;
        var href = formatUrlString(properties[keys[1]].default);
        var isConnect = properties[keys[2]].default;
        var isLink = properties[keys[3]].default;
        var event = properties[keys[4]].default;
        var commodity = properties[keys[5]].default;
        var mainNum1 = properties[keys[6]].default;
        var description1 = properties[keys[7]].default;
        var mainNum2 = properties[keys[8]].default;
        var description2 = properties[keys[9]].default;
        var mainNum3 = properties[keys[10]].default;
        var description3 = properties[keys[11]].default;
        mainNum1 && configuration.push({
            mainNum: mainNum1,
            description: description1
        });
        mainNum2 && configuration.push({
            mainNum: mainNum2,
            description: description2
        });
        mainNum3 && configuration.push({
            mainNum: mainNum3,
            description: description3
        });
        configuration.push({
            txt: txt,
            href: href,
            isConnect: isConnect,
            isLink: isLink,
            event: event,
            commodity: commodity,
            extendProps: {
                'report-event-goal': 'click_offer'
            }
        });
    } else {
        var txt2 = properties[keys[0]].default;
        var href4 = formatUrlString(properties[keys[1]].default);
        var isConnect2 = properties[keys[2]].default;
        var event2 = properties[keys[3]].default;
        var commodity2 = properties[keys[4]].default;
        var mainNum11 = properties[keys[5]].default;
        var description11 = properties[keys[6]].default;
        var mainNum21 = properties[keys[7]].default;
        var description21 = properties[keys[8]].default;
        var mainNum31 = properties[keys[9]].default;
        var description31 = properties[keys[10]].default;
        mainNum11 && configuration.push({
            mainNum: mainNum11,
            description: description11
        });
        mainNum21 && configuration.push({
            mainNum: mainNum21,
            description: description21
        });
        mainNum31 && configuration.push({
            mainNum: mainNum31,
            description: description31
        });
        configuration.push({
            txt: txt2,
            href: href4,
            isConnect: isConnect2,
            event: event2,
            commodity: commodity2,
            extendProps: {
                'report-event-goal': 'click_offer'
            }
        });
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatFreeWithCardOld = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var count = 8;
    for(var i = 0; i < Math.floor(keys.length / count); i++){
        var txt = properties[keys[0 + i * count]].default;
        var href = formatUrlString(properties[keys[1 + i * count]].default);
        var mainNum1 = properties[keys[2 + i * count]].default;
        var description1 = properties[keys[3 + i * count]].default;
        var mainNum2 = properties[keys[4 + i * count]].default;
        var description2 = properties[keys[5 + i * count]].default;
        var mainNum3 = properties[keys[6 + i * count]].default;
        var description3 = properties[keys[7 + i * count]].default;
        if (mainNum1) {
            configuration.push({
                mainNum: mainNum1,
                description: description1
            });
        }
        if (mainNum2) {
            configuration.push({
                mainNum: mainNum2,
                description: description2
            });
        }
        if (mainNum3) {
            configuration.push({
                mainNum: mainNum3,
                description: description3
            });
        }
        configuration.push({
            txt: txt,
            href: href
        });
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatFreeWithBuyNowNew = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    // console.log(properties, 'properties---hahahaahahahah');
    // console.log(keys, 'keys---hahahaahaha');
    var newProperties = clearRandomKey(properties);
    if (Object.prototype.hasOwnProperty.call(newProperties, 'checkbox2')) {
        var count = 8;
        for(var i = 0; i < Math.floor(keys.length / count); i++){
            var title = properties[keys[0 + i * count]].default;
            var content = properties[keys[1 + i * count]].default;
            var butTxt = properties[keys[2 + i * count]].default;
            var butHref = formatUrlString(properties[keys[3 + i * count]].default);
            var isConnect = properties[keys[4 + i * count]].default;
            var isLink = properties[keys[5 + i * count]].default;
            var event = properties[keys[6 + i * count]].default;
            var commodity = properties[keys[7 + i * count]].default;
            if (title) {
                var itemData = {
                    title: title,
                    content: content,
                    isConnect: isConnect,
                    isLink: isLink,
                    but_txt: butTxt,
                    but_href: butHref,
                    event: event,
                    commodity: commodity
                };
                configuration.push(itemData);
            }
        }
    } else {
        var count4 = 7;
        for(var i8 = 0; i8 < Math.floor(keys.length / count4); i8++){
            var title9 = properties[keys[0 + i8 * count4]].default;
            var content5 = properties[keys[1 + i8 * count4]].default;
            var butTxt2 = properties[keys[2 + i8 * count4]].default;
            var butHref2 = formatUrlString(properties[keys[3 + i8 * count4]].default);
            var isConnect3 = properties[keys[4 + i8 * count4]].default;
            var event3 = properties[keys[5 + i8 * count4]].default;
            var commodity3 = properties[keys[6 + i8 * count4]].default;
            if (title9) {
                var itemData8 = {
                    title: title9,
                    content: content5,
                    isConnect: isConnect3,
                    but_txt: butTxt2,
                    but_href: butHref2,
                    event: event3,
                    commodity: commodity3
                };
                configuration.push(itemData8);
            }
        }
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatFreeWithBuyNowOld = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    // console.log(properties, 'properties---hahahaahahahah');
    // console.log(keys, 'keys---hahahaahaha');
    var count = 4;
    for(var i = 0; i < Math.floor(keys.length / count); i++){
        var title = properties[keys[0 + i * count]].default;
        var content = formatUrlInText(properties[keys[1 + i * count]].default);
        var butTxt = properties[keys[2 + i * count]].default;
        var butHref = formatUrlString(properties[keys[3 + i * count]].default);
        if (title) {
            var itemData = {
                title: title,
                content: content,
                but_txt: butTxt,
                but_href: butHref,
                extendProps: {
                    'report-event-goal': 'click_offer',
                    'report-event': 'click_free_card_button',
                    'report-ext1': title,
                    'report-ext2': i,
                    'report-ext3': butTxt,
                    'report-ext4': butHref
                }
            };
            configuration.push(itemData);
        }
    }
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatFreeWithCredit = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    var description = properties[keys[1]].default; // 第二条数据是组件的描述，只有一条
    keys.splice(0, 2); // 把模块名和描述移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    // console.log(properties, 'properties---formatFreeWithCredit');
    // console.log(keys, 'keys---formatFreeWithCredit');
    var count = 9;
    var list = [];
    for(var i = 0; i < Math.floor(keys.length / count); i++){
        var richBtnTxt = [];
        var txt = properties[keys[0 + i * count]].default;
        var isConnect = properties[keys[1 + i * count]].default;
        var type = properties[keys[2 + i * count]].default;
        var event = properties[keys[3 + i * count]].default;
        var commodity = properties[keys[4 + i * count]].default;
        var href = formatUrlString(properties[keys[2 + i * count]].default);
        var modalTitle = properties[keys[3 + i * count]].default;
        var richTextContent = formatUrlInText(properties[keys[4 + i * count]].default);
        var popConfirm = properties[keys[5 + i * count]].default;
        var popConfirmHref = formatUrlString(properties[keys[6 + i * count]].default);
        var popCancel = properties[keys[7 + i * count]].default;
        var popCancelHref = formatUrlString(properties[keys[8 + i * count]].default);
        if (popCancel) {
            richBtnTxt.push({
                type: 'cancel',
                txt: popCancel,
                href: popCancelHref
            });
        }
        if (popConfirm) {
            richBtnTxt.push({
                type: 'confirm',
                txt: popConfirm,
                href: popConfirmHref
            });
        }
        var itemData = {
            txt: txt,
            isConnect: isConnect,
            type: type,
            event: event,
            commodity: commodity,
            href: href,
            modalTitle: modalTitle,
            richTextContent: richTextContent,
            richBtnTxt: richBtnTxt
        };
        list.push(itemData);
    }
    configuration = {
        description: description,
        list: list
    };
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
// 格式化产品卡片的数据格式
// 输入待格式化的字符串，输出 title 和 组件需要的 config 数据
var formatProductCards = function(properties) {
    var keys = Object.keys(properties);
    var modTitle = properties[keys[0]].default;
    var rawConfiguration = properties[keys[1]].default;
    var configuration = rawConfiguration.map(function(item) {
        return clearRandomKey(item);
    });
    return {
        modTitle: modTitle,
        configuration: configuration
    };
};
var clearRandomKey = function(Obj) {
    var noRandomKeyObj = {};
    Object.keys(Obj).forEach(function(key) {
        var key1 = key.slice(0, -7);
        noRandomKeyObj[key1] = Obj[key];
    });
    return noRandomKeyObj;
};
var formatSceneTabsRelevance = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    // let configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var tabsOneList = properties[keys[0]].default || [];
    var configuration = tabsOneList.map(function(tabsOneItem) {
        var ref3 = clearRandomKey(tabsOneItem), _tabOneTitle = ref3.tabOneTitle, tabOneTitle = _tabOneTitle === void 0 ? '' : _tabOneTitle, _tabsTwoList = ref3.tabsTwoList, tabsTwoList = _tabsTwoList === void 0 ? [] : _tabsTwoList;
        var resultList = tabsTwoList.map(function(tabTwoItem) {
            var ref4 = clearRandomKey(tabTwoItem), _tabTwoTitle = ref4.tabTwoTitle, tabTwoTitle = _tabTwoTitle === void 0 ? '' : _tabTwoTitle, _tabTwoImageUpload2 = ref4.tabTwoImageUpload2, tabTwoImageUpload2 = _tabTwoImageUpload2 === void 0 ? '' : _tabTwoImageUpload2, _tabTwoDesc = ref4.tabTwoDesc, tabTwoDesc = _tabTwoDesc === void 0 ? '' : _tabTwoDesc, _tabTwoRelated = ref4.tabTwoRelated, tabTwoRelated = _tabTwoRelated === void 0 ? '' : _tabTwoRelated, _productList = ref4.productList, productList = _productList === void 0 ? [] : _productList;
            // 过滤cms那边的空数组后在转化数据
            var resultProductList = productList.filter(function(item) {
                return Object.keys(item).length > 0;
            }).map(function(productItem) {
                var ref = clearRandomKey(productItem), _productLogo = ref.productLogo, productLogo = _productLogo === void 0 ? '' : _productLogo, _productUrl = ref.productUrl, productUrl = _productUrl === void 0 ? '' : _productUrl, _productTitle = ref.productTitle, productTitle = _productTitle === void 0 ? '' : _productTitle, _productLogoHover = ref.productLogoHover, productLogoHover = _productLogoHover === void 0 ? '' : _productLogoHover;
                return {
                    logo: productLogo,
                    logoHov: productLogoHover,
                    url: productUrl,
                    title: productTitle
                };
            });
            return {
                description: tabTwoTitle,
                imageUrl: tabTwoImageUpload2,
                article: tabTwoDesc && formatUrlInText(tabTwoDesc) || '',
                related: tabTwoRelated,
                product: resultProductList
            };
        });
        return {
            title: tabOneTitle,
            list: resultList
        };
    });
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatButton = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    var bgColor = getComponentsBgColor(properties, keys);
    var tabList = properties[keys[0]].default || [];
    var tabItem = tabList[0] || {}; // 取button列表的第一条
    var tabListClean = clearRandomKey(tabItem);
    var configuration = {};
    configuration.colType = tabListClean.select1 || '';
    configuration.sizeType = tabListClean.select2 || '';
    configuration.alignType = tabListClean.select3 || '';
    configuration.txt = tabListClean.input2 || '';
    configuration.btnTheme = tabListClean.btnTheme || false;
    if (tabListClean.case1) {
        if (tabListClean.case1.clickType1 === 'openUrl' && tabListClean.case1.btnLink) {
            configuration.clickType1 = 'openUrl';
            configuration.callback = function formatButton() {
                window.open(formatUrlString(tabListClean.case1.btnLink));
            };
        } else if (tabListClean.case1.clickType1 === 'btn') {
            configuration.clickType1 = 'btn';
            configuration.configuration = {};
            configuration.configuration.modalTitle = tabListClean.case1.popTitle || '';
            configuration.configuration.richTextContent = tabListClean.case1.textarea || '';
            configuration.configuration.list = [];
            if (tabListClean.case1.boxes2 && tabListClean.case1.boxes2[0] === 'white') {
                var btnLeft = {};
                btnLeft.type = 'cancel';
                switch(tabListClean.case1.case3 && tabListClean.case1.case3.clickType3){
                    case 'cancel':
                        btnLeft.txt = tabListClean.case1.case3.input8 || 'cancel';
                        break;
                    case 'customize':
                        btnLeft.txt = tabListClean.case1.case3.input5 || 'confirm';
                        btnLeft.href = formatUrlString(tabListClean.case1.case3.input6 || '');
                        break;
                }
                configuration.configuration.list.push(btnLeft);
            }
            if (tabListClean.case1.boxes1 && tabListClean.case1.boxes1[0] === 'blue') {
                var btnRight = {};
                btnRight.type = 'confirm';
                switch(tabListClean.case1.case2 && tabListClean.case1.case2.clickType2){
                    case 'cancel':
                        btnRight.txt = tabListClean.case1.case2.input7 || 'cancel';
                        break;
                    case 'customize':
                        btnRight.txt = tabListClean.case1.case2.input3 || 'confirm';
                        btnRight.href = formatUrlString(tabListClean.case1.case2.input4 || '');
                        btnRight.onCallback = function() {
                            if (window.location.href.indexOf('partner') === -1 || btnRight.href.indexOf('partners') === -1) {
                                window.location.href = btnRight.href;
                                return;
                            }
                            checkAccountType();
                        };
                        break;
                }
                configuration.configuration.list.push(btnRight);
            }
        }
    }
    return {
        modTitle: modTitle,
        bgColor: bgColor,
        configuration: configuration
    };
};
// 处理cms组件背景色字段获取
var getComponentsBgColor = function(properties, keys) {
    var bgColor = '';
    if (properties && keys && keys.length > 0 && properties[keys[0]].flag === 'bgColor') {
        bgColor = properties[keys[0]].default || '';
        if (bgColor === 'transparent') {
            // 透明色过滤
            bgColor = '';
        }
        keys.shift();
    }
    return bgColor;
};
var formatBuyProduct = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var productList1;
    var backgroundImage;
    if (keys.length === 2) {
        productList1 = properties[keys[1]].default || [];
        backgroundImage = properties[keys[0]].default || [];
    } else if (keys.length === 1) {
        productList1 = properties[keys[0]].default || [];
    }
    var configuration = productList1.map(function(productItem1) {
        var ref5 = clearRandomKey(productItem1), _product1Title = ref5.product1Title, product1Title = _product1Title === void 0 ? '' : _product1Title, _product1Duration = ref5.product1Duration, product1Duration = _product1Duration === void 0 ? '' : _product1Duration, _product1Content = ref5.product1Content, product1Content = _product1Content === void 0 ? '' : _product1Content, _product1BtnTxt = ref5.product1BtnTxt, product1BtnTxt = _product1BtnTxt === void 0 ? '' : _product1BtnTxt, _product1BtnHref = ref5.product1BtnHref, product1BtnHref = _product1BtnHref === void 0 ? '' : _product1BtnHref, _productList = ref5.productList, productList = _productList === void 0 ? [] : _productList, _product1BgType = ref5.product1BgType, product1BgType = _product1BgType === void 0 ? 'https://staticintl.cloudcachetci.com/cms/backend-cms/VeCP394_essential.png' : _product1BgType;
        var resultList = productList.map(function(productItem) {
            var ref = clearRandomKey(productItem), _sonTitle = ref.sonTitle, sonTitle = _sonTitle === void 0 ? '' : _sonTitle, _sonText = ref.sonText, sonText = _sonText === void 0 ? '' : _sonText;
            return {
                title: sonTitle,
                text: sonText
            };
        });
        return {
            title: product1Title,
            duration: product1Duration,
            content: product1Content,
            but_txt: product1BtnTxt,
            but_href: product1BtnHref,
            text_list: resultList,
            backgroundUrl: product1BgType
        };
    });
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor,
        backgroundImage: backgroundImage
    };
};
var formatNotice = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default || ''; // 第一条数据是模块名称
    var longTimeMode = properties[keys[1]].default || false; // 是否常驻
    var txt = properties[keys[2]].default || ''; // 公告美容
    var type = properties[keys[3]].default || 'notice'; // 默认为通知类型
    return {
        modTitle: modTitle,
        longTimeMode: longTimeMode,
        txt: txt,
        type: type
    };
};
var formatNewBanner = function(properties) {
    var ref6 = clearRandomKey(properties), _bannerBg = ref6.bannerBg, bannerBg = _bannerBg === void 0 ? {} : _bannerBg, _bannerLogo = ref6.bannerLogo, bannerLogo = _bannerLogo === void 0 ? {} : _bannerLogo, _bannerVideo = ref6.bannerVideo, bannerVideo = _bannerVideo === void 0 ? {} : _bannerVideo, _bannerTitle = ref6.bannerTitle, bannerTitle = _bannerTitle === void 0 ? {} : _bannerTitle, _bannerDesc = ref6.bannerDesc, bannerDesc = _bannerDesc === void 0 ? {} : _bannerDesc, _lightTheme = ref6.lightTheme, lightTheme = _lightTheme === void 0 ? {} : _lightTheme, _bannerBtnList = ref6.bannerBtnList, bannerBtnList = _bannerBtnList === void 0 ? {} : _bannerBtnList, _linkList = ref6.linkList, linkList = _linkList === void 0 ? {} : _linkList, _liveType = ref6.liveType, liveType = _liveType === void 0 ? {} : _liveType; // 去除cms配置里面key的随机数得到真的key
    var resultList = (bannerBtnList.default || []).map(function(bannerBtnItem, index) {
        var ref = clearRandomKey(bannerBtnItem), _btnHref = ref.btnHref, btnHref = _btnHref === void 0 ? '' : _btnHref, _btnText = ref.btnText, btnText = _btnText === void 0 ? '' : _btnText, _btnVideoBg = ref.btnVideoBg, btnVideoBg = _btnVideoBg === void 0 ? '' : _btnVideoBg, _btnVideoUrl = ref.btnVideoUrl, btnVideoUrl = _btnVideoUrl === void 0 ? '' : _btnVideoUrl;
        return {
            href: formatUrlString(btnHref),
            label: btnText,
            filedVideoBg: btnVideoBg,
            filedVideoList: btnVideoUrl,
            extendProps: {
                'report-event': 'click_banner_button',
                'report-ext1': index,
                'report-ext2': btnText,
                'report-ext3': btnHref
            }
        };
    });
    var resultLinkList = (linkList.default || []).map(function(linkItem) {
        // 聚合多合一链接列表
        var ref = clearRandomKey(linkItem), _href = ref.href, href = _href === void 0 ? '' : _href, _text = ref.text, text = _text === void 0 ? '' : _text, _chosed = ref.chosed, chosed = _chosed === void 0 ? false : _chosed;
        return {
            href: href,
            text: text,
            chosed: chosed
        };
    });
    return {
        title: bannerTitle.default || '',
        content: bannerDesc.default || '',
        backgroundUrl: bannerBg.default || '',
        backgroundUrlLogo: bannerLogo.default || '',
        backgroundVideoUrl: bannerVideo.default || '',
        lightTheme: lightTheme.default || false,
        buttonList: resultList,
        linkList: resultLinkList,
        liveType: liveType.default || ''
    };
};
// 异形logo+描述tab数据结构解析
var formatCustomersTab = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var tabsOneList = properties[keys[0]].default || [];
    var configuration = tabsOneList.map(function(tabsOneItem, index) {
        var noRandomKeyTabOne = clearRandomKey(tabsOneItem);
        var tabOneTitle = noRandomKeyTabOne.tabOneTitle || '';
        var customersList = noRandomKeyTabOne.customersList || [];
        var resultList = customersList.map(function(customersItem, index1) {
            var noRandomKeyObj = clearRandomKey(customersItem);
            return {
                key: index1 + 1,
                title: noRandomKeyObj.customersTitle || '',
                source: noRandomKeyObj.customersLogo || '',
                content: noRandomKeyObj.customersDesc && formatUrlInText(noRandomKeyObj.customersDesc) || '',
                href: noRandomKeyObj.customersHref || '',
                hrefText: noRandomKeyObj.customersHrefText || ''
            };
        });
        return {
            key: index + 1,
            title: tabOneTitle,
            list: resultList
        };
    });
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
// 资源组件数据结构解析
var formatProductResource = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    // let configuration = [];
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var ref10 = clearRandomKey(properties), desc = ref10.desc, _cardData = ref10.cardData, cardData = _cardData === void 0 ? {} : _cardData, _videoData = ref10.videoData, videoData = _videoData === void 0 ? {} : _videoData, _txtData = ref10.txtData, txtData = _txtData === void 0 ? {} : _txtData;
    var resultDesc = desc ? desc.default : '';
    var ref7 = clearRandomKey(cardData.properties), _cardDataTitle = ref7.cardDataTitle, cardDataTitle = _cardDataTitle === void 0 ? {} : _cardDataTitle, _rowspan = ref7.rowspan, rowspan = _rowspan === void 0 ? {} : _rowspan, _cardDataList = ref7.cardDataList, cardDataList = _cardDataList === void 0 ? {} : _cardDataList;
    var ref8 = clearRandomKey(videoData.properties), _videoDataTitle = ref8.videoDataTitle, videoDataTitle = _videoDataTitle === void 0 ? {} : _videoDataTitle, _videoDataList = ref8.videoDataList, videoDataList = _videoDataList === void 0 ? {} : _videoDataList;
    var ref9 = clearRandomKey(txtData.properties), _txtDataTitle = ref9.txtDataTitle, txtDataTitle = _txtDataTitle === void 0 ? {} : _txtDataTitle, _txtDataList = ref9.txtDataList, txtDataList = _txtDataList === void 0 ? {} : _txtDataList;
    // 处理资源组件中帮助和文档部分数据解析
    var resultCardList = (cardDataList.default || []).map(function(cardItem, index) {
        var ref = clearRandomKey(cardItem), _cardDataItemTitle = ref.cardDataItemTitle, cardDataItemTitle = _cardDataItemTitle === void 0 ? '' : _cardDataItemTitle, _cardDataItemContent = ref.cardDataItemContent, cardDataItemContent = _cardDataItemContent === void 0 ? '' : _cardDataItemContent, _cardDataItemImg = ref.cardDataItemImg, cardDataItemImg = _cardDataItemImg === void 0 ? '' : _cardDataItemImg, _cardDataItemHref = ref.cardDataItemHref, cardDataItemHref = _cardDataItemHref === void 0 ? '' : _cardDataItemHref, _tabIndex = ref.tabIndex, tabIndex = _tabIndex === void 0 ? '' : _tabIndex, _bindingNum = ref.bindingNum, bindingNum = _bindingNum === void 0 ? '' : _bindingNum;
        return {
            title: cardDataItemTitle,
            content: cardDataItemContent,
            href: cardDataItemHref,
            img: cardDataItemImg,
            tabIndex: tabIndex,
            bindingNum: bindingNum,
            extendProps: {
                'report-event': 'click_productResource_card',
                'report-ext1': index,
                'report-ext2': cardDataItemTitle,
                'report-ext3': cardDataItemHref
            }
        };
    });
    var resultCardData = {
        title: cardDataTitle.default || '',
        rowspan: rowspan && rowspan.default ? ROW_NUMBER.TWO : ROW_NUMBER.THREE,
        configuration: resultCardList
    };
    // 处理资源组件中视频教程部分数据解析
    var resultVideoList = (videoDataList.default || []).map(function(videoItem, index) {
        var ref = clearRandomKey(videoItem), _videoDataDescription = ref.videoDataDescription, videoDataDescription = _videoDataDescription === void 0 ? '' : _videoDataDescription, _videoDataItemImg = ref.videoDataItemImg, videoDataItemImg = _videoDataItemImg === void 0 ? '' : _videoDataItemImg, _videoDataItemBgUrl = ref.videoDataItemBgUrl, videoDataItemBgUrl = _videoDataItemBgUrl === void 0 ? '' : _videoDataItemBgUrl, _videoDataItemPlayUrl = ref.videoDataItemPlayUrl, videoDataItemPlayUrl = _videoDataItemPlayUrl === void 0 ? '' : _videoDataItemPlayUrl, _videoDataItemType = ref.videoDataItemType, videoDataItemType = _videoDataItemType === void 0 ? false : _videoDataItemType;
        return {
            description: videoDataDescription,
            videoBgUrl: videoDataItemBgUrl,
            videoPlayUrl: videoDataItemPlayUrl,
            img: videoDataItemType ? '' : videoDataItemImg,
            type: videoDataItemType ? 'right' : 'center',
            extendProps: {
                'report-event': 'click_productResource_video',
                'report-ext1': index,
                'report-ext2': videoDataDescription,
                'report-ext3': videoDataItemPlayUrl
            }
        };
    });
    var resultVideoData = {
        title: videoDataTitle.default || '',
        configuration: resultVideoList
    };
    // 处理资源组件中其他文档部分数据解析
    var resultTxtList = (txtDataList.default || []).map(function(txtItem) {
        var ref = clearRandomKey(txtItem), _txtDataItemHead = ref.txtDataItemHead, txtDataItemHead = _txtDataItemHead === void 0 ? '' : _txtDataItemHead, _txtDataItemTitle = ref.txtDataItemTitle, txtDataItemTitle = _txtDataItemTitle === void 0 ? '' : _txtDataItemTitle, _txtDataItemDescription = ref.txtDataItemDescription, txtDataItemDescription = _txtDataItemDescription === void 0 ? '' : _txtDataItemDescription;
        // const formatContent = formatATagInHtmlNew(txtDataItemDescription, 'click_productResource_txt_richtext_href');
        var formatContent = formatUrlInText(txtDataItemDescription, {
            reportEvent: 'click_productResource_txt_richtext_href'
        });
        return {
            head: txtDataItemHead,
            title: txtDataItemTitle,
            description: formatContent
        };
    });
    var resultTxtData = {
        title: txtDataTitle.default || '',
        configuration: resultTxtList
    };
    return {
        modTitle: modTitle,
        desc: resultDesc,
        cardData: resultCardData,
        videoData: resultVideoData,
        txtData: resultTxtData,
        bgColor: bgColor
    };
};
// 白皮书数据结构解析
var formatWhitepaper = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var whitepaperList = properties[keys[0]].default || [];
    var configuration = whitepaperList.map(function(whitepaperItem) {
        var ref = clearRandomKey(whitepaperItem), _title = ref.title, title = _title === void 0 ? '' : _title, _description = ref.description, description = _description === void 0 ? '' : _description, _thumbnail = ref.thumbnail, thumbnail = _thumbnail === void 0 ? '' : _thumbnail, _href = ref.href, href = _href === void 0 ? '' : _href;
        return {
            title: title,
            description: description,
            thumbnail: thumbnail,
            href: href
        };
    });
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
// FAQ数据结构解析
var formatFaq = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var faqTabList = properties[keys[0]].default || [];
    var configuration = faqTabList.map(function(faqTabItem, index) {
        var ref11 = clearRandomKey(faqTabItem), _titleTab = ref11.titleTab, titleTab = _titleTab === void 0 ? '' : _titleTab, _list = ref11.list, list = _list === void 0 ? [] : _list;
        var resultList = list.map(function(faqItem) {
            var ref = clearRandomKey(faqItem), _title = ref.title, title = _title === void 0 ? '' : _title, _text = ref.text, text = _text === void 0 ? '' : _text;
            return {
                title: title,
                text: text
            };
        });
        return {
            key: index + 1,
            titleTab: titleTab,
            list: resultList
        };
    });
    return {
        modTitle: modTitle,
        configuration: configuration,
        bgColor: bgColor
    };
};
var formatProductsService = function(properties) {
    var noRandomKeyData = clearRandomKey(properties); // 去除cms配置里面key的随机数得到真的key
    var title = noRandomKeyData.input0 ? noRandomKeyData.input0.default || '' : ''; // banner背景图
    var color = noRandomKeyData.color ? noRandomKeyData.color.default || '' : ''; // banner背景图
    return {
        title: title,
        color: color
    };
};
// 代金券数据结构解析
var formatFreeWithCreditIteration = function(properties) {
    var _loop = function(i) {
        var item = properties[keys[i]];
        var ref = clearRandomKey(item.properties), _title = ref.title, title = _title === void 0 ? {} : _title, _agreement = ref.agreement, agreement = _agreement === void 0 ? {} : _agreement, _price = ref.price, price = _price === void 0 ? {} : _price, _txt = ref.txt, txt3 = _txt === void 0 ? {} : _txt, _href = ref.href, href = _href === void 0 ? {} : _href, _type = ref.type, type = _type === void 0 ? {} : _type, _isConnect = ref.isConnect, isConnect = _isConnect === void 0 ? {} : _isConnect, _isLink = ref.isLink, isLink = _isLink === void 0 ? {} : _isLink, _event = ref.event, event = _event === void 0 ? {} : _event, _commodity = ref.commodity, commodity = _commodity === void 0 ? {} : _commodity;
        var resultAgreement = (agreement.default || []).map(function(agreementItem) {
            var agreementKeys = Object.keys(agreementItem);
            var txt = agreementItem[agreementKeys[0]] || '';
            return {
                txt: txt
            };
        });
        var buttonConfig = {
            txt: txt3.default || '',
            href: href.default || '',
            colType: 'blue',
            text: '文字',
            'text-icon': '文字+图标',
            sizeType: 'middle',
            alignType: 'center',
            onCallback: null
        };
        buttonConfig.onCallback = function formatFreeWithCreditIteration() {
            href && window.open(formatUrlString(href));
        };
        var itemData = {
            type: type.default || '1',
            title: title.default || '',
            agreement: resultAgreement,
            price: price.default || '0',
            isConnect: isConnect.default || '',
            isLink: isLink.default || '',
            event: event.default || false,
            commodity: commodity.default || '',
            buttonConfig: buttonConfig
        };
        resultConfiguration.push(itemData);
    };
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var ref13 = clearRandomKey(properties), _headConfig = ref13.headConfig, headConfig = _headConfig === void 0 ? {} : _headConfig;
    var ref12 = clearRandomKey(headConfig.properties), _description = ref12.description, description = _description === void 0 ? {} : _description, _list = ref12.list, list = _list === void 0 ? {} : _list;
    // 处理头部配置
    var resultHeadList = (list.default || []).map(function(headItem) {
        var ref = clearRandomKey(headItem), _txt = ref.txt, txt = _txt === void 0 ? '' : _txt, _headCase = ref.headCase, headCase = _headCase === void 0 ? {} : _headCase;
        var _href = headCase.href, href = _href === void 0 ? '' : _href, _type = headCase.type, type = _type === void 0 ? 'a' : _type, _modalTitle = headCase.modalTitle, modalTitle = _modalTitle === void 0 ? '' : _modalTitle, _richTextContent = headCase.richTextContent, richTextContent = _richTextContent === void 0 ? '' : _richTextContent, _richBtnTxt = headCase.richBtnTxt, richBtnTxt = _richBtnTxt === void 0 ? [] : _richBtnTxt;
        return {
            txt: txt,
            href: href,
            type: type,
            modalTitle: modalTitle,
            richTextContent: richTextContent,
            richBtnTxt: richBtnTxt
        };
    });
    var resultHeadConfig = {
        description: description.default || '',
        list: resultHeadList
    };
    keys.shift(); // 把head配置移出，继续遍历后面的数据
    var resultConfiguration = [];
    for(var i = 0; i < keys.length; i++)_loop(i);
    return {
        modTitle: modTitle,
        headConfig: resultHeadConfig,
        configuration: resultConfiguration,
        bgColor: bgColor
    };
};
/**
 * 音视频数据结构解析
 * @param filterConfigData 传入的当前页面所有的组件数据
 * @param audioData 音视频所用的带组件组合的tab组件数据
 * @param Jp2component 处理组件的function
 */ var formatAudioVideoComponent = function(filterConfigData, audioData, Jp2component) {
    var filterConfigDataTemp = _toConsumableArray(filterConfigData);
    // 处理Customers下组件id
    filterConfigDataTemp = doComponentIdEvent(filterConfigDataTemp);
    try {
        var tmp = audioData.component_object, componentObj = tmp === void 0 ? {} : tmp;
        var properties = JSON.parse(componentObj).properties; // 获取cms的具体配置信息
        if (Object.prototype.toString.call(properties) === '[object Object]') {
            var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
            var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
            keys.shift(); // 把模块名移出，继续遍历后面的数据
            // 处理组件背景色字段
            var bgColor = getComponentsBgColor(properties, keys);
            var ref15 = clearRandomKey(properties), _audioVideo = ref15.audioVideo, audioVideo = _audioVideo === void 0 ? {} : _audioVideo;
            var resultConfiguration = (audioVideo.default || []).map(function(item3, id) {
                var ref18 = clearRandomKey(item3), _dataType = ref18.dataType, dataType = _dataType === void 0 ? '' : _dataType, _titleTab = ref18.titleTab, titleTab = _titleTab === void 0 ? '' : _titleTab, _multiComponentList1 = ref18.multiComponentList, multiComponentList1 = _multiComponentList1 === void 0 ? [] : _multiComponentList1, _simpleData = ref18.simpleData, simpleData = _simpleData === void 0 ? [] : _simpleData, _iconsDesc = ref18.iconsDesc, iconsDesc = _iconsDesc === void 0 ? [] : _iconsDesc, _jumpData = ref18.jumpData, jumpData = _jumpData === void 0 ? {} : _jumpData;
                var data = {
                    label: titleTab,
                    bindingNum: "audio_".concat(id),
                    extendProps: {
                        'report-event': 'click_tab_one_level',
                        'report-ext1': "audio_".concat(id),
                        'report-ext2': titleTab
                    }
                };
                var oneLevelMultiComponent = multiComponentList1.map(function(item) {
                    var ref = clearRandomKey(item), _multiComponent = ref.multiComponent, multiComponent = _multiComponent === void 0 ? '' : _multiComponent;
                    return multiComponent;
                });
                var ref14 = doTabComponentFilterEvent(oneLevelMultiComponent, filterConfigDataTemp), renderFilterConfigData1 = ref14.renderFilterConfigData, filterConfigDataWithComp1 = ref14.filterConfigDataWithComp;
                filterConfigDataTemp = filterConfigDataWithComp1;
                if (renderFilterConfigData1.length > 0) {
                    data.render = function(onCallback) {
                        return renderFilterConfigData1.map(function(item, index) {
                            /*#__PURE__*/ return _jsx(Jp2component, {
                                data: item,
                                index: index,
                                onCallback: onCallback
                            }, "tab_".concat(index));
                        });
                    };
                }
                if ('singleData' === dataType) {
                    // 单数据结构处理
                    var resultSimpleData = simpleData.map(function(simpleDataItem, index) {
                        var ref20 = clearRandomKey(simpleDataItem), _txt = ref20.txt, txt = _txt === void 0 ? '' : _txt, _href = ref20.href, href = _href === void 0 ? '' : _href, _multiComponentList = ref20.multiComponentList, multiComponentList = _multiComponentList === void 0 ? [] : _multiComponentList;
                        var multiComponent1 = multiComponentList.map(function(item) {
                            var ref = clearRandomKey(item), _multiComponent = ref.multiComponent, multiComponent = _multiComponent === void 0 ? '' : _multiComponent;
                            return multiComponent;
                        });
                        var ref19 = doTabComponentFilterEvent(multiComponent1, filterConfigDataTemp), renderFilterConfigData = ref19.renderFilterConfigData, filterConfigDataWithComp = ref19.filterConfigDataWithComp;
                        filterConfigDataTemp = filterConfigDataWithComp;
                        var bindingNum = "single_".concat(id, "_").concat(index);
                        return {
                            txt: txt,
                            href: href,
                            bindingNum: bindingNum,
                            render: function(onCallback) {
                                return renderFilterConfigData.map(function(item, index1) {
                                    return(/*#__PURE__*/ _jsx(Jp2component, {
                                        data: item,
                                        index: index1,
                                        onCallback: onCallback
                                    }, "".concat(bindingNum, "_").concat(index)));
                                });
                            },
                            extendProps: {
                                'report-event': 'click_tab_two_level',
                                'report-ext1': "single_".concat(id, "_").concat(index),
                                'report-ext2': titleTab
                            }
                        };
                    });
                    data.pane = {
                        simpleData: resultSimpleData
                    };
                } else if ('multiData' === dataType) {
                    // 多层数据结构处理
                    var resultIconsDesc = iconsDesc.map(function(iconsDescItem, iconIndex) {
                        var ref21 = clearRandomKey(iconsDescItem), _txt1 = ref21.txt, txt4 = _txt1 === void 0 ? '' : _txt1, _desc = ref21.desc, desc = _desc === void 0 ? '' : _desc, _iconsDescChildren = ref21.iconsDescChildren, iconsDescChildren = _iconsDescChildren === void 0 ? [] : _iconsDescChildren;
                        var resultIconsDescChildren = iconsDescChildren.map(function(iconsDescChildrenItem, iconsChildIndex) {
                            var ref22 = clearRandomKey(iconsDescChildrenItem), _icon = ref22.icon, icon = _icon === void 0 ? '' : _icon, _txt2 = ref22.txt, txt5 = _txt2 === void 0 ? '' : _txt2, _iconsDescChildrenChildren = ref22.iconsDescChildrenChildren, iconsDescChildrenChildren = _iconsDescChildrenChildren === void 0 ? [] : _iconsDescChildrenChildren;
                            // eslint-disable-next-line no-unused-vars
                            var resultIconsDescChildrenChildren = iconsDescChildrenChildren.map(function(iconsDescChildrenChildrenItem, iconsChildChildIndex) {
                                var _txt = iconsDescChildrenChildrenItem.txt, txt = _txt === void 0 ? '' : _txt, _href = iconsDescChildrenChildrenItem.href, href = _href === void 0 ? '' : _href, _multiComponentList = iconsDescChildrenChildrenItem.multiComponentList, multiComponentList = _multiComponentList === void 0 ? [] : _multiComponentList;
                                var multiComponent2 = multiComponentList.map(function(item) {
                                    var _multiComponent = item.multiComponent, multiComponent = _multiComponent === void 0 ? '' : _multiComponent;
                                    return multiComponent;
                                });
                                var ref = doTabComponentFilterEvent(multiComponent2, filterConfigDataTemp), renderFilterConfigData = ref.renderFilterConfigData, filterConfigDataWithComp = ref.filterConfigDataWithComp;
                                filterConfigDataTemp = filterConfigDataWithComp;
                                var bindingNum = "multi_child_".concat(id, "_").concat(iconIndex, "_").concat(iconsChildIndex, "_").concat(iconsChildChildIndex);
                                return {
                                    txt: txt,
                                    href: href,
                                    bindingNum: bindingNum,
                                    render: function(onCallback) {
                                        return renderFilterConfigData.map(function(item, index) {
                                            return(/*#__PURE__*/ _jsx(Jp2component, {
                                                data: item,
                                                index: index,
                                                onCallback: onCallback
                                            }, "".concat(bindingNum, "_").concat(index)));
                                        });
                                    },
                                    extendProps: {
                                        'report-event': 'click_tab_two_level',
                                        'report-ext1': "multi_child_".concat(id, "_").concat(iconIndex, "_").concat(iconsChildIndex, "_").concat(iconsChildChildIndex),
                                        'report-ext2': txt
                                    }
                                };
                            });
                            return {
                                txt: txt5,
                                img: icon,
                                bindingNum: "multi_".concat(id, "_").concat(iconIndex, "_").concat(iconsChildIndex),
                                children: resultIconsDescChildrenChildren
                            };
                        });
                        return {
                            txt: txt4,
                            desc: desc,
                            children: resultIconsDescChildren
                        };
                    });
                    data.pane = {
                        iconsDesc: resultIconsDesc
                    };
                } else if ('jump' === dataType) {
                    // 默认走jump
                    var hasIcon = jumpData.hasIcon, _href1 = jumpData.href, href5 = _href1 === void 0 ? '' : _href1;
                    data.jump = {
                        href: href5,
                        icons: hasIcon
                    };
                }
                return data;
            });
            return {
                audioUsedComponent: filterConfigDataTemp,
                audioData: {
                    modTitle: modTitle,
                    bgColor: bgColor,
                    configuration: resultConfiguration
                }
            };
        }
    } catch (e) {
        logger.error('[Error] formatAudioVideoComponent', e);
        return {
            audioUsedComponent: [],
            audioData: {}
        };
    }
};
// 处理cms那边配置的组件，针对Customers里面组件id不唯一问题
var doComponentIdEvent = function(filterConfigData) {
    return filterConfigData.map(function(item) {
        var tmp = item.component_id, componentId = tmp === void 0 ? '' : tmp, tmp1 = item.component_object, componentObj = tmp1 === void 0 ? {} : tmp1;
        var diff = JSON.parse(componentObj).diff;
        return {
            component_id: componentId === 'Customers' ? "".concat(componentId, "/").concat(diff) : componentId,
            component_object: componentObj
        };
    });
};
// tab组件内对包含的组件进行过滤
var doTabComponentFilterEvent = function(multiComponentList, filterConfigData) {
    var filterConfigDataWithComp = _toConsumableArray(filterConfigData);
    var renderFilterConfigData = [];
    multiComponentList.forEach(function(item) {
        var index = filterConfigDataWithComp.findIndex(function(value) {
            return value.component_id === item;
        });
        if (index >= 0) {
            renderFilterConfigData.push(filterConfigDataWithComp[index]);
            filterConfigDataWithComp[index] = {};
        }
    });
    filterConfigDataWithComp = filterConfigDataWithComp.filter(function(item) {
        return item.component_id;
    });
    return {
        filterConfigDataWithComp: filterConfigDataWithComp,
        renderFilterConfigData: renderFilterConfigData
    };
};
// 合作伙伴表格模块数据结构解析
var formatParther = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var ref23 = clearRandomKey(properties), _contentList = ref23.contentList, contentList = _contentList === void 0 ? {} : _contentList, _description = ref23.description, description = _description === void 0 ? {
        default: ''
    } : _description, _titleList = ref23.titleList, titleList = _titleList === void 0 ? {} : _titleList;
    var resultTitleList = (titleList.default || []).map(function(item) {
        return clearRandomKey(item);
    });
    var resultContentList = (contentList.default || []).map(function(item4) {
        var ref = clearRandomKey(item4), titleOf = ref.titleOf, title = ref.title, _textList = ref.textList, textList = _textList === void 0 ? [] : _textList;
        var resultTextList = textList.map(function(item) {
            return clearRandomKey(item);
        });
        return {
            titleOf: titleOf,
            title: title,
            textList: resultTextList
        };
    });
    return {
        modTitle: modTitle,
        description: description.default || '',
        contentList: resultContentList,
        titleList: resultTitleList,
        bgColor: bgColor
    };
};
// 代码示例模块数据结构解析
var formatCode = function(properties) {
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = getComponentsBgColor(properties, keys);
    var ref = clearRandomKey(properties), title = ref.title, _configuration = ref.configuration, configuration = _configuration === void 0 ? [] : _configuration, _desc = ref.desc, desc = _desc === void 0 ? {
        default: ''
    } : _desc, _href = ref.href, href = _href === void 0 ? {
        default: ''
    } : _href;
    var resultConfiguration = (configuration.default || []).map(function(item) {
        return clearRandomKey(item);
    });
    return {
        modTitle: modTitle,
        title: title.default,
        desc: desc.default,
        href: href.default,
        configuration: resultConfiguration,
        bgColor: bgColor
    };
};
// 纯logo组件
var formatFlexInternationalLogo = function(properties) {
    var ref24 = clearRandomKey(properties), _modTitle = ref24.modTitle, modTitle = _modTitle === void 0 ? {} : _modTitle, _color = ref24.color, color = _color === void 0 ? {} : _color, _desc = ref24.desc, desc = _desc === void 0 ? {} : _desc, _configuration = ref24.configuration, configuration = _configuration === void 0 ? {} : _configuration; // 去除cms配置里面key的随机数得到真的key
    var resultList = (configuration.default || []).map(function(item) {
        var ref = clearRandomKey(item), _imageSrc = ref.imageSrc, imageSrc = _imageSrc === void 0 ? '' : _imageSrc, _href = ref.href, href = _href === void 0 ? '' : _href;
        var extendProps = {
            'report-event': 'click_international_logo_href',
            'report-ext1': href
        };
        return {
            imageSrc: imageSrc,
            href: href,
            extendProps: extendProps
        };
    });
    return {
        modTitle: modTitle.default || '',
        color: color.default || '',
        desc: desc.default || '',
        configuration: resultList
    };
};
export default {
    formatContact: formatContact,
    formatArchitecture: formatArchitecture,
    formatBanner: formatBanner,
    formatBenefits: formatBenefits,
    formatBenefitsTab: formatBenefitsTab,
    formatBuyNowNew: formatBuyNowNew,
    formatBuyNowOld: formatBuyNowOld,
    formatQuickstarts: formatQuickstarts,
    formatCustomers: formatCustomers,
    formatMultipleScenarios: formatMultipleScenarios,
    formatRelatedProducts: formatRelatedProducts,
    formatScenarios: formatScenarios,
    formatScenariosCard: formatScenariosCard,
    formatStoriesScenarios: formatStoriesScenarios,
    formatSceneChange: formatSceneChange,
    formatProductIntroduction: formatProductIntroduction,
    formatSceneTabs: formatSceneTabs,
    formatFreeWithCardNew: formatFreeWithCardNew,
    formatFreeWithCardOld: formatFreeWithCardOld,
    formatFreeWithBuyNowNew: formatFreeWithBuyNowNew,
    formatFreeWithBuyNowOld: formatFreeWithBuyNowOld,
    formatFreeWithCredit: formatFreeWithCredit,
    formatProductCards: formatProductCards,
    formatSceneTabsRelevance: formatSceneTabsRelevance,
    formatButton: formatButton,
    formatBuyProduct: formatBuyProduct,
    formatNotice: formatNotice,
    formatNewBanner: formatNewBanner,
    formatProductsService: formatProductsService,
    formatCustomersTab: formatCustomersTab,
    formatProductResource: formatProductResource,
    formatWhitepaper: formatWhitepaper,
    formatFaq: formatFaq,
    formatPriceTabData: formatPriceTabData,
    formatFreeWithCreditIteration: formatFreeWithCreditIteration,
    formatCode: formatCode,
    clearRandomKey: clearRandomKey,
    getComponentsBgColor: getComponentsBgColor,
    formatAudioVideoComponent: formatAudioVideoComponent,
    formatParther: formatParther,
    formatFlexInternationalLogo: formatFlexInternationalLogo
};
